/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CurrencyEnum = 'AUD' | 'CNY' | 'EUR' | 'GBP' | 'JPY' | 'USD';

export const CurrencyEnum = {

    AUD: 'AUD' as CurrencyEnum,

    CNY: 'CNY' as CurrencyEnum,

    EUR: 'EUR' as CurrencyEnum,

    GBP: 'GBP' as CurrencyEnum,

    JPY: 'JPY' as CurrencyEnum,

    USD: 'USD' as CurrencyEnum
};

